import React from "react";
import { DatePicker } from "antd";
import { disableFutureDates } from "../../../services/util";
import moment from "moment";

const { RangePicker } = DatePicker;

const DateRangePicker = ({selectedDates, setSelectedDates}) => {
    
    function handleDateChange(e) {
        let start_date =
            e !== null ? moment(e[0]).startOf("day") : selectedDates[0];
        let end_date =
            e !== null ? moment(e[1]).startOf("day") : selectedDates[1];
            setSelectedDates([start_date, end_date]);
    }

    return (
        <RangePicker
            allowClear={false}
            disabledDate={disableFutureDates}
            defaultValue={[moment(selectedDates[0]), moment(selectedDates[1])]}
            value={[moment(selectedDates[0]), moment(selectedDates[1])]}
            className="dashboard-date-search margin-right-5 select-container"
            onChange={handleDateChange}
            format="MM/DD/YYYY"
            ranges={{
                Today: [moment(), moment()],
                Yesterday: [
                    moment().subtract(1, "day"),
                    moment().subtract(1, "day"),
                ],
                "Last 7 Days": [moment().subtract(7, "day"), moment()],
                "Last 30 Days": [moment().subtract(29, "day"), moment()],
                "Current Month": [moment().startOf("month"), moment()],
                "Last Month": [
                    moment().subtract(1, "month").startOf("month"),
                    moment().subtract(1, "month").endOf("month"),
                ],
                "Last 3 Month": [moment().subtract(3, "month"), moment()],
            }}
        />
    );
};

export default DateRangePicker;
